import React, { useState } from 'react'
import CommittedCost from './CommittedCost'
import { Grid, Typography } from '@mui/material'
import CustomTabs from 'components/CustomTabs'
import ScheduleActivitiesSection from './ScheduleActivitiesSection'
import { CAPEX_MENU_ACCESS, COMMITTED_COST_ACCESS } from 'helpers/permissionConfig'


const tabs = [{ label: "Capex", index: 0, permissionKey: [CAPEX_MENU_ACCESS] }, { label: "Committed Cost", index: 1, permissionKey: [COMMITTED_COST_ACCESS] }]

const Capex = () => {
    const [tabValue, setTabValue] = useState(0);
    const showMspSchedule = true;

    const handleTabChange = (e, value) => {
        setTabValue(value)
    }
    return (
        <>
            <Grid container spacing={0}>
                <Grid size={12} sx={{ bgcolor: "#FFFFFF", px: 2, py: 1.75, borderBottom: "1px solid #E2E8F0" }}>
                    <Typography sx={{ fontWeight: 650, fontSize: "20px", lineHeight: "27px", color: "#0F172A", fontFamily: "Outfit, sans-serif" }}>Capex</Typography>
                    <Typography sx={{ mt: 0.2, fontSize: "12px", lineHeight: "17px", color: "#64748B" }}>Review capital expenditure, committed cost, and schedule-linked cost performance.</Typography>
                </Grid>

                <Grid
                    size={12}
                    sx={{ px: 2, pt: 1, backgroundColor: "#FFFFFF", borderBottom: "1px solid #E2E8F0" }}
                >
                    <CustomTabs tabs={tabs} handleTabChange={handleTabChange} tabValue={tabValue} />
                </Grid>


                {tabValue === 0 && (
                    <Grid size={12} sx={{ p: 2 }}>

                        <ScheduleActivitiesSection showMspSchedule={showMspSchedule} isShowMonths={true} exportButton={true} columnFiltering={true} />
                    </Grid>
                )}


                {tabValue === 1 && (
                    <Grid size={12} sx={{ p: 2 }}>
                        <CommittedCost />
                    </Grid>
                )}
            </Grid>

        </>
    )
}

export default Capex
